/**
 * I return a zero-arg function which when invoked will use the passed selector
 * function(s) to obtain values, and if any are different from their
 * corresponding prior value (according to `===`), pass them to the work
 * function.
 *
     f = distinctUntilChangedBuilder(
       () => 1,
       () => 2,
       (a, b) => {
         console.log("work", a, b);
         return Math.max(a, b);
       }
     )
     const x = f(); // x == 2, logs "work 1 2"
     const y = f(); // y == 2
 *
 * This is sorta like Flux's Container's pair: getStores and calculateState, but
 * with memoization.
 *
 * This is sorta like Rx's operator of the same name, but twisted to work with
 * selectors instead of an Observable pipe.
 *
 * This is sorta like reselect.
 *
 * @param selector function (or several of them) used to obtain parameter(s) for
 *  the work function
 * @param work function to invoke w/ current value(s) when they change
 * @return {Function} a zero-arg function returning work's result
 */
function distinctUntilChangedBuilder(
    selector,
    work
) {
    const l = arguments.length - 1; // last one is work
    const selectors = [];
    let lastValues = [];
    for (let i = 0; i < l; i++) {
        selectors[i] = arguments[i];
        lastValues[i] = selectors[i]();
    }
    work = arguments[l];
    let lastResult = undefined;
    return () => {
        const nextValues = [];
        let invoke = false;
        for (let i = 0; i < l; i++) {
            nextValues[i] = selectors[i]();
            invoke = invoke || lastValues[i] !== nextValues[i];
        }
        if (invoke) {
            lastValues = nextValues;
            lastResult = work.apply(null, lastValues);
        }
        return lastResult;
    };
}

export default distinctUntilChangedBuilder;



// WEBPACK FOOTER //
// ./app/data/util/distinctUntilChangedBuilder.js